import {createSelector} from 'reselect';
export const demands = state => state.demands;
export const demandsSelector = createSelector(demands, data => data);
